module.exports = __webpack_public_path__ + "static/media/img-logo-loading-l.eaed73db.svg";